var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"filestyle",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.previewFiles}})])
}
var staticRenderFns = []

export { render, staticRenderFns }